import React, { FC, ReactNode } from 'react'
import imageResize, { generateSrcSet } from 'project/image-proxy-web'
import useWindowSize from 'components/util/useWindowSize'
import classNames from 'classnames'

type RobotImage = {
  alt?: string
  desktop: {
    src: string
    dimensions: {
      width: number
      height: number
    }
  }
  mobile: {
    src: string
    dimensions: {
      width: number
      height: number
    }
  }
}

type LeftRobotCardType = {
  className?: string
  image: RobotImage
  children: ReactNode
  reverseColumnOrder?: boolean
  imageContainerContent?: ReactNode
  imageContainerWidth?: string
  imageStyle?: React.CSSProperties
  overrideAllImageStyles?: boolean
}

const LeftRobotCard: FC<LeftRobotCardType> = ({
  children,
  className,
  image,
  imageContainerContent,
  imageContainerWidth,
  imageStyle,
  overrideAllImageStyles = false,
  reverseColumnOrder = false,
}) => {
  const size = useWindowSize()
  const {
    alt: imageAlt = 'Colorful robot figure with stickers',
    desktop,
    mobile,
  } = image

  return (
    <div className={`card ${className}`}>
      <div
        className={classNames('d-flex flex-lg-row', {
          'flex-column': !reverseColumnOrder,
          'flex-column-reverse': reverseColumnOrder,
        })}
      >
        <div
          className='d-flex flex-column position-relative'
          style={imageContainerWidth ? { width: imageContainerWidth } : {}}
        >
          {imageContainerContent}
          {size.isLgOrHigher ? (
            <img
              {...generateSrcSet(
                desktop.src,
                desktop.dimensions.width,
                desktop.dimensions.height,
              )}
              loading='lazy'
              alt={imageAlt}
              className={classNames('h-100 rounded-left-img')}
              style={
                !size.isXlOrHigher && !overrideAllImageStyles
                  ? {
                      objectFit: 'cover',
                      objectPosition: 'right top',
                      width: '100%',
                    }
                  : {
                      ...imageStyle,

                      left: 0,
                      position: 'absolute',
                      top: 0,
                    }
              }
            />
          ) : (
            <img
              {...generateSrcSet(
                mobile.src,
                mobile.dimensions.width,
                mobile.dimensions.height,
              )}
              loading='lazy'
              alt={imageAlt}
              className={classNames('w-100 h-auto', {
                'rounded-bottom-img': reverseColumnOrder,
                'rounded-top-img': !reverseColumnOrder,
              })}
            />
          )}
        </div>
        {children}
      </div>
    </div>
  )
}

export default LeftRobotCard
